import { render, staticRenderFns } from "./PendingAccountingNotesList.vue?vue&type=template&id=65d8caf2"
import script from "./PendingAccountingNotesList.vue?vue&type=script&lang=js"
export * from "./PendingAccountingNotesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports